import * as React from "react"
import { Col, Container, Row } from "react-bootstrap"
import { Layout } from "../components/layout"
import { Head } from "../components/seo"

export const PrivacyPolicyPage: React.FC = () => {
  return (
    <Layout title="PRIVACY POLICY" subtitle="個人情報保護方針">
      <Head title="PRIVACY POLICY" />
      <div className="my-4">
        <Container className="my-5">
          <Row>
            <Col md="12">
              <p>
                当社は、コンピューター情報を扱う企業として、その情報の保護の重要性は強く認識しております。<br />
                そのために、これらの指針を文面化しお客様の個人情報の保護に役立ててまいります。<br />
                当社は、個人情報保護に関する法令及びその他の規範を遵守し、保有する個人情報の安全管理のために、組織的､人的、物理的及び技術的安全管理措置を講じます。<br />
                そのために、当該法令及びその他の規範に適合した社内諸規定及びコンプライアンス・プログラムを整備して、これを継続的に改善してまいります。<br />
                当社は、不正の手段により個人情報を取得いたしません。<br />
                またお客様よりお預かりする個人情報の利用目的の特定及び明示に務めてまいります。個人情報を取得する場合又は利用目的を変更する場合は、その利用目的を公表いたします。また、利用目的を変更する場合には、変更前の利用目的と相当の関連性を有すると合理的に判断される範囲において変更を行うものとします。<br />
                当社は、お預かりした個人情報の正確性及び安全性の確保に努めてまいります。<br />
                個人情報への不正アクセス、個人情報の紛失、破壊、改ざん及び漏洩等を防止するために、適切な情報セキュリティ対策を講じます。また、個人データを正確かつ最新の内容に保つよう努めてまいります。
              </p>
              <p>
                株式会社エムケイシステム<br />
                代表取締役　山本 寿彦
              </p>

              <h2 className="h4 pb-2 mb-3 mt-5 border-bottom">1）個人情報の利用目的</h2>
              <p className="ms-3">
                当社は、お客様からお預かりする個人情報の利用目的を以下のように特定いたします。<br />
                当社及び当社のグループ会社が取り扱う各種製品・サービスに関するご案内<br />
                当社及び当社のグループ会社が主催・共催・協賛・出展するセミナー・展示会等に関するご案内、お申込の確認、また入場券等のお届け。<br />
                当社及び当社のグループ会社が行う顧客満足度調査等のアンケートのご依頼。<br />
                当社及び当社のグループ会社がお客様個人を特定できない形で個人情報を統計的に処理した情報を集約し分析する等して調査結果としてまとめたものの公表。<br />
                当社がお客様に対して行う業務上のご連絡。<br />
                当社がお客様とのご契約を履行するうえで必要となる事項(各種サービスへのご登録のご確認やサービスのご提供等)。 当社が行う各種製品・サービスのご請求、お支払とその確認等。
              </p>

              <h2 className="h4 pb-2 mb-3 mt-5 border-bottom">2）お客様からのお問合せ又はご依頼等への対応</h2>
              <p className="ms-3">
                個人情報に関する当社の社内諸規定及びコンプライアンス・プログラムに準拠した秘密保持契約等の契約を締結し利用目的を精査・確認した上で当社のグループ会社へお客様の個人情報を提供すること。<br />
                その他、お客様とのご契約上の当社の責任を果たすため、より良い製品・サービスを開発するため、お客様へ有用な情報をお届けするため、その他正当な目的のために、お客様に事前にお知らせし、または公表した目的。<br />
                (注)当社のグループ会社とは、上記利用目的が遂行される時点で、当社が総株主の議決権の過半数を所有する会社をいいます。
              </p>

              <h2 className="h4 pb-2 mb-3 mt-5 border-bottom">3）第三者への提供及び委託先への監督について</h2>
              <p className="ms-3">
                当社のグループ会社の販売促進活動に資することを目的として、お客様に関する氏名・電話番号・住所・メールアドレス・年齢・勤務先・所属部署・当社製品の購入乃至導入履歴及び購入目的・お客様がお使いになっているパソコン等の端末に関する種類及び使用環境・お客様がお使いになっているソフトウェアに関する種類及び使用環境・お客様がお使いになっているインターネットに関する種類及び使用環境などの個人情報を、データ送信及び書面交付の方法により当社のグループ会社へ提供することがあります。<br />
                当社のグループ会社への提供を停止することを希望されるお客様は当社までお申出下さい。<br />
                当社のグループ会社、委託先等への個人データの預託に際しては、個人情報に関する当社の社内諸規定及びコンプライアンス・プログラムに準拠した秘密保持契約等の契約を締結し、適切な監督を行うものとします。
              </p>

              <h2 className="h4 pb-2 mb-3 mt-5 border-bottom">4）保有個人データの開示等に関して</h2>
              <p className="ms-3">
                当社は、お客様ご本人からの保有個人データの開示、訂正、利用停止等のご請求に対して以下により適切に対応してまいります。<br />
                当社は、お客様から保有個人データの開示ご請求があった際には、当社業務の適正な実施に著しい支障を及ぼすおそれがある場合その法令に定める場合を除き、お客様に対して当該保有個人データの開示を行います。<br />
                当社は、保有個人データの内容が事実と異なる場合には、お客様からのご請求により、利用目的の達成に必要な範囲内において、当該保有個人データの内容の訂正、追加又は削除を行います。ただし、訂正等を行うことによって、提供することが困難になる、もしくは出来なくなる製品やサービスが発生する場合があります。<br />
                当社は、保有個人データが利用目的の制限に違反して取り扱われている場合、もしくは、不正の手段により取得された場合、又は法令に違反して第三者に提供されている場合には、お客様からのご請求により、違反を是正するために必要な限度で当該保有個人データの利用の停止又は消去を行い、又は第三者への提供を停止します。<br />
                ただし、利用停止等を行うことが困難な場合であって、お客様の権利利益を保護するために必要なこれに代わるべき措置をとるときは、当該措置をもって利用停止に替えることとします。
              </p>

              <h2 className="h4 pb-2 mb-3 mt-5 border-bottom">5）開示等のご請求及びお問い合わせ先</h2>
              <p className="ms-3">
                上記 1）に記載した保有個人データの開示等のご請求につきましては、当社の定める書式に従って頂きます。<br />
                当社における個人情報保護に関してご質問等がある場合には、当社個人情報管理責任者までご連絡ください。
              </p>

              <h2 className="h4 pb-2 mb-3 mt-5 border-bottom">6）当社の個人情報管理責任者</h2>
              <p className="ms-3">
                株式会社エムケイシステム　代表取締役　山本 寿彦<br />
              </p>

              <h2 className="h4 pb-2 mb-3 mt-5 border-bottom">7）個人情報保護方針等の変更</h2>
              <p className="ms-3">
                当社は、以上の個人情報保護方針等の内容に関して、お客様の個人情報の安全管理のために必要と判断した際には、事前の通知・公表を行うことなく変更を行うことがあります。<br />
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  )
}